/**
 * Object for a Nominating a teacher
 */
class NominateTeacher {
    /**
     * Creates a new NominateTeacher Object.
     * @param {String} teacherName
     * @param {Boolean} isAnonymous
     * @param {String} submitName
     * @param {String} msg
     * @param {String} confirmationEmail
     * @param {Timestamp} createTime
     * @param {Boolean} makePublic
     * @param {Boolean} isApproved
     */
    constructor (teacherName, isAnonymous, submitName, msg, confirmationEmail, createTime, makePublic, isApproved = false) {
        this.docId;
        this.teacherName = teacherName;
        this.isAnonymous = isAnonymous;
        this.submitName = submitName;
        this.msg = msg;
        this.confirmationEmail = confirmationEmail;
        this.createTime = createTime;
        this.makePublic = makePublic;
        this.isApproved = isApproved;
    }
}

// Firestore data converter
const NominateTeacherConverter = {
    /**
     * Converts the NominateTeacher to a firestore document.
     * 
     * @param {NominateTeacher} nom
     * Holds the NominateTeacher object we want in the DB.
     * 
     * @returns {JSON}
     * Firestore JSON object of the NominateTeacher.
     */
    toFirestore: (nom) => {
        return {
            teacherName: nom.teacherName,
            isAnonymous: nom.submitName === '',
            submitName: nom.submitName,
            msg: nom.msg,
            confirmationEmail: nom.confirmationEmail,
            createTime: nom.createTime,
            makePublic: nom.makePublic,
            isApproved: nom.isApproved,
        };
    },

    /**
     * Converts a Firestore document to a NominateTeacher object.
     * 
     * @param {*} snapshot 
     * @param {*} options 
     * @returns {NominateTeacher}
     * a NominateTeacher object.
     */
    fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options);
        let r =  new NominateTeacher(
            data.teacherName,
            data.isAnonymous,
            data.submitName,
            data.msg,
            data.confirmationEmail,
            data.createTime,
            data.makePublic,
            data.isApproved,
        )

        r.docId = snapshot.id;
        return r;
    }
}

module.exports = { NominateTeacher, NominateTeacherConverter }
